<!-- EllipsisText.vue -->
<template>
    <el-tooltip popper-class="popper-tooltip" :disabled="!isEllipsis || !showTooltip" :content="tooltipContent || text" :placement="placement" :effect="effect" :enterable="enterable" :popper-class="popperClass" :open-delay="openDelay" :offset="offset" :max-width="tooltipMaxWidth">
        <div ref="textRef" class="ellipsis-text" :class="{ 'multi-line': rows > 1 }" :style="textStyles">
            <slot>{{ text }}</slot>
        </div>
    </el-tooltip>
</template>

<script>
    export default {
        name: 'EllipsisText',
        props: {
            // 文本内容
            text: {
                type: String,
                default: ''
            },
            // tooltip内容，不设置则使用text
            tooltipContent: {
                type: String,
                default: ''
            },
            // 最大宽度
            width: {
                type: [String, Number],
                default: '100%'
            },
            // 文本行数，超过1时启用多行省略
            rows: {
                type: Number,
                default: 1
            },
            // tooltip位置
            placement: {
                type: String,
                default: 'top'
            },
            // tooltip主题
            effect: {
                type: String,
                default: 'dark'
            },
            // 鼠标是否可进入tooltip
            enterable: {
                type: Boolean,
                default: false
            },
            // 自定义tooltip类名
            popperClass: {
                type: String,
                default: ''
            },
            // 显示延迟
            openDelay: {
                type: Number,
                default: 0
            },
            // 偏移量
            offset: {
                type: Number,
                default: 0
            },
            // tooltip最大宽度
            tooltipMaxWidth: {
                type: String,
                default: '300px'
            },
            // 是否显示tooltip，即使文本溢出
            showTooltip: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                isEllipsis: false,
                observer: null
            };
        },
        computed: {
            textStyles () {
                const styles = {
                    maxWidth: typeof this.width === 'number' ? `${this.width}px` : this.width
                };

                if (this.rows > 1) {
                    styles.webkitLineClamp = this.rows;
                }

                return styles;
            }
        },
        mounted () {
            this.checkEllipsis();

            // 使用ResizeObserver监听元素大小变化
            if (window.ResizeObserver) {
                this.observer = new ResizeObserver(() => {
                    this.checkEllipsis();
                });
                this.observer.observe(this.$refs.textRef);
            } else {
                // 降级方案
                window.addEventListener('resize', this.checkEllipsis);
            }

            // 监听内容变化
            this.$watch('text', this.checkEllipsis);
        },
        updated () {
            this.$nextTick(() => {
                this.checkEllipsis();
            });
        },
        beforeDestroy () {
            if (this.observer) {
                this.observer.disconnect();
            } else {
                window.removeEventListener('resize', this.checkEllipsis);
            }
        },
        methods: {
            checkEllipsis () {
                const el = this.$refs.textRef;
                if (!el) return;

                if (this.rows > 1) {
                    // 多行文本判断
                    this.isEllipsis = el.scrollHeight > el.clientHeight;
                } else {
                    // 单行文本判断
                    this.isEllipsis = el.scrollWidth > el.clientWidth;
                }
            }
        }
    };
</script>

<style scoped>
    .ellipsis-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .multi-line {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        white-space: normal;
        word-break: break-all;
    }
</style>
